export default __webpack_public_path__ + "static/media/delete.9cd87cc6.svg";